<template>
  <div class="inform">
    <el-row type="flex">
      <el-col :span="6" :offset="1">
        <div class="row_flex">
          <div class="label">告知时间：</div>
          <div class="val">{{ detail.createDate }}</div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="row_flex">
          <div class="label">状态：</div>
          <div class="val">{{ detail.state }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="row_flex">
          <div class="label">客户编码：</div>
          <div class="val">{{ detail.cusCode }}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="row_flex">
          <div class="label">客户名称：</div>
          <div class="val">{{ detail.cusName }}</div>
        </div>
      </el-col>
    </el-row>
    <div class="title">
      一、我司已批复{{ detail.year }}年{{ detail.month }}月给予贵司费用支持额度为：
    </div>
    <el-row type="flex">
      <el-col :span="6" :offset="1">
        <div class="row_flex">
          <div class="label">搭赠/折扣额度：</div>
          <div class="val">{{ detail.discountLimit }}</div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="row_flex">
          <div class="label">返利额度：</div>
          <div class="val">{{ detail.rebateLimit }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="row_flex">
          <div class="label">销售奖励额度：</div>
          <div class="val">{{ detail.saleRewardLimit || 0 }}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="row_flex">
          <div class="label">其他费用额度：</div>
          <div class="val">{{ detail.otherLimit }}</div>
        </div>
      </el-col>
    </el-row>
    <div class="title">
      二、以上额度仅为我司在本月度内对贵司市场建设最大可支持额度，不代表实际支持费用，具体费用金额以贵司提报且我司最终批复为准，且超出以上额度内容，我司有权不予支付
    </div>
    <div class="title">三、在无我司书面授权的情形下，我司销售人员等均无权向贵司承诺任何费用</div>
    <div class="title">四、自贵司收到此告知函之日起，即表示知悉以上内容。顺颂商祺！</div>
    <div class="tips">注：超过5个工作日未确认默认已知悉</div>
  </div>
</template>

<script>
import { notifyFindById } from '@/api/api'

export default {
  name: 'info',
  props: {
    formConfig: Object
  },
  data() {
    return {
      detail: {}
    }
  },
  watch: {
    formConfig: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.row) {
          this.getDetail()
        }
      }
    }
  },
  created() {
    // if (this.formConfig.row) {
    //   this.getDetail();
    // }
  },
  methods: {
    // 获取详情
    getDetail() {
      notifyFindById(this.formConfig.row.id).then((res) => {
        this.detail = res.result
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.inform {
  .row_flex {
    display: flex;

    .label {
      min-width: 70px;
    }
  }

  .title {
    font-size: 15px;
    margin: 20px 0;
  }

  .tips {
    margin-top: 80px;
    color: red;
    text-align: right;
  }
}
</style>
